module.exports = __webpack_public_path__ + "static/media/twitter.293726c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/twitter.svg
// module id = 1167
// module chunks = 0